// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3RxMK","buttons":"Footer_buttons__3GOxz"};